// extracted by mini-css-extract-plugin
module.exports = {"selectInput":"SelectInput_selectInput__LvteY"};